import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const MATERIALTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.MaterialType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const MATERIALTYPE_CONFIG = {
  entityName: 'MaterialType',
  localizationKey: 'General::Entity.MaterialType',
  fields: MATERIALTYPE_FIELDS,
  permission: 'GeneralConsumables.MaterialTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
